import { Transaction } from '@solana/web3.js';
import {
  RechargeSigners,
  ServerMessage,
  UserInfo,
  WithdrawSigners,
} from '../types.ds';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export const updateBalance = async (
  action: string,
  playerId: string,
  balance: number,
  signature?: string,
  transaction?: Transaction,
  signers?: RechargeSigners | WithdrawSigners
) => {
  try {
    const req = await fetch(`${API_ENDPOINT}/post/${playerId}`, {
      method: 'PATCH',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        updatedBalance: +balance.toFixed(2),
        type: action,
        signature: signature || '',
        transaction: transaction || [],
        signers: signers?.signers || {},
      }),
    });
    if (req.status === 200) {
      const res: UserInfo = await req.json();
      return res;
    } else {
      const res: ServerMessage = await req.json();
      return res;
    }
  } catch (error: any) {
    throw new Error('Failed to update balance.');
    // eslint-disable-next-line no-console
  }
};
